"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGrowthOptions = void 0;
const constants_1 = require("./constants");
const useToolsOptionsSelector_1 = require("./useToolsOptionsSelector");
const useGrowthOptions = () => {
    return (0, useToolsOptionsSelector_1.useToolsOptionsSelector)(state => (state === null || state === void 0 ? void 0 : state.growthOptions) || constants_1.DEFAULT_GROWTH_OPTIONS);
};
exports.useGrowthOptions = useGrowthOptions;
